import Logo from "@/components/feature/Logo";

const links = [
  { label: "Ocean", href: "#ocean" },
  { label: "Atuação", href: "#atuacao" },
  { label: "Portfólio", href: "#portfolio" },
  { label: "Contato", href: "#contato" },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 pt-16 md:pt-20">
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 gap-12 border-b border-background-100/10 pb-14 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <Logo variant="light" size="md" />
            <p className="ocean-label mt-7 text-[10px] text-background-100/60">
              Ocean Companhia de Comércio LTDA
            </p>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-background-100/60">
              Importação e comercialização de produtos para o mercado nacional.
            </p>
          </div>

          <div>
            <p className="ocean-label text-[10px] text-accent-300/80">Navegação</p>
            <nav className="mt-5 flex flex-col gap-3" aria-label="Navegação do rodapé">
              {links.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="cursor-pointer text-sm text-background-100/70 transition-colors duration-300 hover:text-accent-300"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <p className="ocean-label text-[10px] text-accent-300/80">Dados</p>
            <ul className="mt-5 space-y-3 text-sm text-background-100/70">
              <li>
                CNPJ: <span className="text-background-100/90">52.798.570/0002-53</span>
              </li>
              <li>Maceió - AL</li>
              <li>
                <a
                  href="mailto:comercial@oceancompanhia.com.br"
                  className="break-all transition-colors duration-300 hover:text-accent-300"
                >
                  comercial@oceancompanhia.com.br
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-start gap-3 py-7 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-100/50">
            © {year} OCEAN COMPANHIA DE COMÉRCIO LTDA. Todos os direitos reservados.
          </p>
          <p className="ocean-label text-[9px] text-background-100/40">Maceió · Alagoas · Brasil</p>
        </div>
      </div>
    </footer>
  );
}